export default __webpack_public_path__ + "static/media/Paris-Cake.de6285c2.jpg";